// extracted by mini-css-extract-plugin
export default {"main_Container":"Letstalk_main_Container__mF7VN"};